"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateFileUploadDto = exports.CreateFileUploadDto = void 0;
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class CreateFileUploadDto {
}
exports.CreateFileUploadDto = CreateFileUploadDto;
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CreateFileUploadDto.prototype, "companyType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateFileUploadDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateFileUploadDto.prototype, "companyId", void 0);
const mapped_types_1 = require("@nestjs/mapped-types");
class UpdateFileUploadDto extends (0, mapped_types_1.PartialType)(CreateFileUploadDto) {
}
exports.UpdateFileUploadDto = UpdateFileUploadDto;
